"use client";

import { Check, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import type { AppLocale } from "@/features/resume/content/dashboard-copy";
import { fullAccessDetailsCopy } from "@/features/resume/content/full-access-details-copy";

export function FullAccessDetailsModal({ locale, onClose }: { locale: AppLocale; onClose(): void }) {
  const copy = fullAccessDetailsCopy[locale];

  return <div className="fixed inset-0 z-50 grid place-items-center bg-foreground/35 p-4" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section role="dialog" aria-modal="true" aria-labelledby="full-access-details-title" className="w-full max-w-md rounded-2xl border bg-card p-5 shadow-xl sm:p-7">
      <header className="flex items-center justify-between gap-4">
        <h2 id="full-access-details-title" className="text-xl font-semibold">{copy.title}</h2>
        <Button type="button" variant="ghost" size="icon" onClick={onClose} aria-label={copy.close}><X /></Button>
      </header>

      <div role="table" aria-label={copy.title} className="mt-4 max-h-[60vh] overflow-y-auto rounded-xl border">
        <div role="row" className="grid grid-cols-[1.2fr_1fr] gap-2 bg-muted/50 px-4 py-2.5">
          <span role="columnheader" className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{copy.functionality}</span>
          <span role="columnheader">
            <span className="block text-sm font-semibold text-primary">{copy.fullAccess}</span>
            <span className="block text-xs text-muted-foreground">{copy.duration}</span>
          </span>
        </div>
        {copy.rows.map(([feature, full]) => (
          <div key={feature} role="row" className="grid grid-cols-[1.2fr_1fr] gap-2 border-t px-4 py-3">
            <span role="rowheader" className="text-sm font-medium">{feature}</span>
            <span role="cell" className="flex items-start gap-1.5 text-sm text-muted-foreground"><Check className="mt-0.5 size-4 shrink-0 text-emerald-600" />{full}</span>
          </div>
        ))}
      </div>
    </section>
  </div>;
}
